"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpactorSwarm = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var RemoveAnyPlants_1 = require("../../deferredActions/RemoveAnyPlants");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var ImpactorSwarm = (function (_super) {
    __extends(ImpactorSwarm, _super);
    function ImpactorSwarm() {
        return _super.call(this, {
            cost: 11,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.IMPACTOR_SWARM,
            cardType: CardType_1.CardType.EVENT,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.JOVIAN, 2); }),
            metadata: {
                cardNumber: 'C16',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.heat(12, { digit: Options_1.digit }).br;
                    b.minus().plants(2, { all: Options_1.all });
                }),
                description: 'Requires 2 Jovian tags. Gain 12 heat. Remove up to 2 plants from any player.',
            },
        }) || this;
    }
    ImpactorSwarm.prototype.play = function (player) {
        player.game.defer(new RemoveAnyPlants_1.RemoveAnyPlants(player, 2));
        player.heat += 12;
        return undefined;
    };
    return ImpactorSwarm;
}(Card_1.Card));
exports.ImpactorSwarm = ImpactorSwarm;
